import { render, staticRenderFns } from "./deleteProductSeckill.vue?vue&type=template&id=acbc20fa"
import script from "./deleteProductSeckill.vue?vue&type=script&lang=js"
export * from "./deleteProductSeckill.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports